import { InjectionToken } from '@angular/core'
import { GrowthBookConfig } from '../models/growthbook-config'

export const GROWTHBOOK_CONFIG = new InjectionToken<GrowthBookConfig>('GROWTHBOOK_CONFIG');